import { h } from 'preact'
import { useState } from 'preact/hooks'
import { t } from '../beacon-i18n.js'

/**
 * ArticleFeedback — "Választ kapott a kérdésre?" visszajelzés-sáv.
 * Three states: question → emoji pair → thank-you, each cross-fading in
 * (see plan "CSS Animációk" → feedback-crossfade). Purely client-side:
 * no backend endpoint, just a PostHog capture via window.phCapture.
 */
export function ArticleFeedback({ slug, title }) {
  const [state, setState] = useState('question') // 'question' | 'reacting' | 'done'

  function reveal() {
    setState('reacting')
  }

  function react(helpful) {
    window.phCapture?.('beacon_article_feedback_given', {
      feature: 'support_widget',
      action: 'given',
      slug,
      title,
      helpful,
    })
    setState('done')
  }

  return (
    <div class="beacon-article-feedback" key={state}>
      {state === 'question' && (
        <div class="beacon-feedback-content beacon-feedback-question">
          <span>{t('support.beacon.feedback.question')}</span>
          <button type="button" class="beacon-feedback-smiley-btn" aria-label={t('support.beacon.feedback.question_aria')} onClick={reveal}>
            <i class="bi bi-emoji-smile"></i>
          </button>
        </div>
      )}

      {state === 'reacting' && (
        <div class="beacon-feedback-content beacon-feedback-reacting">
          <button type="button" class="beacon-feedback-emoji-btn" aria-label={t('support.beacon.feedback.yes_aria')} onClick={() => react(true)}>
            👍
          </button>
          <button type="button" class="beacon-feedback-emoji-btn" aria-label={t('support.beacon.feedback.no_aria')} onClick={() => react(false)}>
            👎
          </button>
        </div>
      )}

      {state === 'done' && (
        <div class="beacon-feedback-content beacon-feedback-done">
          <i class="bi bi-check-circle-fill"></i>
          <span>{t('support.beacon.feedback.thanks')}</span>
        </div>
      )}
    </div>
  )
}
